//@flow
import React from 'react';
import { HTMLView } from 'components/atoms/htmlView';
import { words } from 'lodash';
import { withRouter } from 'react-router-dom';
import { StringUtil } from 'utils/StringUtil';
import { Banner } from 'components/atoms/banner';
import { BannerVideoButton } from 'components/atoms/bannerVideoButton';
import { FooterExploreButton } from 'components/atoms/footerExploreButton';
import { useViewport } from 'components/templates/viewportProvider';
import type { ProjectAnnouncement } from 'types/project';
//eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  theme: string,
  data: {
    announcement: ProjectAnnouncement,
    ourHomesBanner: any, // TODO:
    onGetInTouchClick: () => void,
  },
};
const HomesBanner = (props: Props) => {
  const { height, isMobile } = useViewport();
  const {
    ourHomesBanner: {
      title,
      description,
      image,
      image_mobile,
      thumbnail,
      thumbnail_mobile,
      banner_video,
    },
  } = props.data;

  const renderFullDescription = () => {
    return (
      <HTMLView
        className={'homes-banner-description'}
        html={description}
        tagName={'p'}
      />
    );
  };

  let countLengthOf = StringUtil.sliceHtml(description);
  const length = words(countLengthOf).length;
  let bannerImageUrl = image;
  let thumbNailUrl = thumbnail;
  let className = 'homes-banner';
  if (isMobile) {
    bannerImageUrl = image_mobile;
    thumbNailUrl = thumbnail_mobile;
  }

  return (
    <div className={className} style={{ height }} id={'banner'}>
      <Banner
        imageUrl={bannerImageUrl}
        thumbNailUrl={thumbNailUrl}
        title={title}
        containerClassName={'intro'}
        bannerText={'title'}
        length={length}
        description={renderFullDescription()}
      />
      {banner_video && <BannerVideoButton videoUrl={banner_video} />}
      {isMobile && <FooterExploreButton sectionName={'our-differences'} />}
    </div>
  );
};
export default withRouter(HomesBanner);
